import React from "react";
import logo from "../img/m4p.jpg";

const Uploading = () => (
  <div style={{ marginTop: "150px" }}>
    <img src={logo} alt="logo" width="150" />
    <h2>Votre pitch est en cours d'upload</h2>
    <p>
      Le délai d'upload peut prendre plusieurs minutes en fonction de votre connection, de la durée et de la qualité de votre vidéo.
    </p>
    <p>
      Vous recevrez un mail de SPEEKER lorsque votre pitch sera disponible. Vous pourrez alors le partager ou le supprimer via votre espace personnel.
    </p>
    <p>
      En attendant nous vous conseillons d'
      <a href="https://speeker.netlify.app/pitchs" style={{color: "blue"}}>
        évaluer vos pairs
      </a>.
    </p>
  </div>
);

export default Uploading;
